import {
  EnvIdentifier,
  LogLevel,
  environmentSettings,
} from './environment-types';

export const environment: environmentSettings = {
  production: true,
  envIdentifier: EnvIdentifier.STAGING,
  logSettings: {
    minLevels: {
      telemetry: LogLevel.WARN,
      console: LogLevel.ALL,
      stash: LogLevel.DEBUG,
    },
    routerLog: false,
  },
  transferApiBaseUrl:
    'https://server.staging.zaver.com/checkout/testing/transfer',
  transferFrameBaseUrl: 'https://test-transfer.zaver.com/home',
  finApiUrl: 'https://webform-sandbox.finapi.io',
};

export const SERVER_BASE_URL =
  'https://server.staging.zaver.com/checkout/payer';
export const SERVER_LOAN_CALCULATOR_BASE_URL =
  'https://server.staging.zaver.com/widget/loan-calculator';
export const SERVER_EXTERNAL_BASE_URL =
  'https://server.staging.zaver.com/checkout/epi';
